import React from "react";
import styled from "styled-components";
import { themeColors } from "../../../../sharedStyles";
import { getStaticUrl } from "js/config";
import { BlueButton } from "js/react/components/UiComponents";
import { NoResourcesNotices } from "js/react/views/UserOptions/dialogs/NoResourcesNotices";

const CenterAlignContainer = styled.div`
  height: calc(100% - 80px);
  display: flex;
  align-items: center;
  grid-column: 1/-1;
`;

const StyledNoMatchesFound = styled.div`
  margin: 0 auto;
  border: 1px solid ${themeColors.warning};
  background: white;
  min-width: 400px;
  text-align: center;
  padding: 40px;
  
  h2 { 
    font-size: 22px;
    margin-bottom: 0;
  }

  h4 {
    font-size: 16px;
    font-weight: lighter;
    margin-top: 5px;
  }
`;

const NoTemplatesFound = styled.div`
  max-width: 600px;
  background: white;
  padding: 20px 40px;
  margin: 0 auto;
  text-align: center;

  img {
    width: 60px;
  }

  h3 {
    padding: 25px 0 15px 0;
    font-size: 20px;
    color: ${themeColors.darkGray};
    font-weight: bold;
  }

  p {
    font-size: 14px;
    color: ${themeColors.gray};
    padding-bottom: 30px;
  }

  .suggest-a-template {
    padding-top: 15px;
  }

  a {
    font-weight: bold;
  }

`;

export function NoMatchesFoundContainer(props) {
    const { context } = props;

    // determine the message to show
    const display = context === "templates" ? <NoTemplatesFoundMessage {...props} />
        : <DefaultMessage {...props} />;

    return (
        <CenterAlignContainer>
            {display}
        </CenterAlignContainer>
    );
}

function NoTemplatesFoundMessage({ onAddClassicSlide, urlSuggestionForm }) {
    return (
        <NoTemplatesFound>
            <img src={getStaticUrl(`/images/dialogs/sad-robot.png`)} />
            <h3>No matches found.</h3>
            <p>Try a different search term or design your slide from scratch with a blank Classic Slide.</p>
            <BlueButton onClick={onAddClassicSlide}>Add Classic Slide</BlueButton>

            {urlSuggestionForm && (
                <div className="suggest-a-template">
                    <a href={urlSuggestionForm} target="_blank">Suggest a Template.</a>
                </div>
            )}
        </NoTemplatesFound>
    );
}

function DefaultMessage({ message }) {
    return (
        <NoResourcesNotices>
            <h1>No matches found.</h1>
            <p>{message || "Try a different search term."}</p>
        </NoResourcesNotices>
    );
}
